module.exports = "/_next/static/images/c6d5c0ac0f34ee28d56e638a080d6cb2-nobureaucracy@3x.png";